export const LANDING_PAGE_URL = 'https://amlbot.com';

export const LANDING_LINKS = {
  TRANSACTION_MONITORING_PAGE_URL: `${LANDING_PAGE_URL}/transaction-monitoring`,
  B2B_PAGE_URL: `${LANDING_PAGE_URL}/api-integration/`,
  BLOG_PAGE_URL: `https://blog.amlbot.com`,
  KYC_PAGE_URL: `${LANDING_PAGE_URL}/kyc`,
  TRACER_PAGE_URL: `${LANDING_PAGE_URL}/tracer`,
  TRAINING_PAGE_URL: `${LANDING_PAGE_URL}/training`,
  CONSULTING_PAGE_URL: `${LANDING_PAGE_URL}/crypto-compliance-consulting`,
  CRYPTO_CHECKER_PAGE_URL: `${LANDING_PAGE_URL}/crypto-checker`,
  INVESTIGATION_PAGE_URL: `${LANDING_PAGE_URL}/reclaim-crypto`,
  CERTIFICATIONS_PAGE_URL: `${LANDING_PAGE_URL}/certifications`,
  ANALYZE_PAGE_URL: `${LANDING_PAGE_URL}/what-do-we-analyze`,
  ABOUTUS_PAGE_URL: `${LANDING_PAGE_URL}/about-us`,
  PRESSKIT_PAGE_URL: `${LANDING_PAGE_URL}/press-kit`,
  CAREERS_PAGE_URL: `${LANDING_PAGE_URL}/careers`,
  TELEGRAM_AML_SUPPORT_BOT_URL: `https://t.me/amlbot_support_bot`,
  TELEGRAM_URL: 'https://t.me/AML_GROUP',
  LINKEDIN_URL: 'https://linkedin.com/company/amlbot/',
  TWITTER_URL: 'https://x.com/AMLBotHQ',
  YOUTUBE_URL: 'https://youtube.com/@amlbot',
  MEDIUM_URL: 'https://medium.com/@AMLBot',
  USER_AGREEMENT_PDF_URL: `${LANDING_PAGE_URL}/files/AMLBot_SERVICE_AGREEMENT.pdf`,
  PRIVACY_POLICY_PAGE_URL: `${LANDING_PAGE_URL}/privacy-policy`,
  TERMS_OF_SERVICE_PAGE_URL: `${LANDING_PAGE_URL}/terms-of-service`,
};
